/* Carrossel de banners da home.

   O arrastar é nativo: o trilho é um scroller com scroll-snap (ver
   lof-banner.css), então dedo no celular e trackpad no desktop já funcionam
   sem JS nenhum. Este arquivo cuida de três coisas só: passar sozinho,
   acompanhar os pontinhos e parar de passar quando atrapalharia. */
(function () {
  'use strict';

  /* Depois de arrastar, quem está olhando escolheu aquele banner. Voltar a
     passar 6 segundos depois é tirar da mão da pessoa o que ela foi ver. */
  var PAUSA_APOS_TOQUE = 8000;

  function montar(raiz) {
    if (raiz.getAttribute('data-bn-pronto') === '1') return;

    var trilho = raiz.querySelector('[data-bn-trilho]');
    if (!trilho) return;

    var slides = Array.prototype.slice.call(raiz.querySelectorAll('[data-bn-slide]'));
    /* Um banner só não é carrossel: sem automático, sem pontinhos, sem
       listener nenhum. A seção continua válida com um bloco. */
    if (slides.length < 2) return;

    raiz.setAttribute('data-bn-pronto', '1');

    var pontos = Array.prototype.slice.call(raiz.querySelectorAll('[data-bn-ponto]'));
    var intervalo = (parseInt(raiz.getAttribute('data-bn-intervalo'), 10) || 6) * 1000;
    var auto = raiz.getAttribute('data-bn-auto') === 'true';
    var reduz = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var atual = 0;
    var timer = null;
    var retomar = null;
    var lendoScroll = null;
    var conferirChegada = null;

    /* UMA fonte de verdade: a posição do scroll. `ir()` só pede a rolagem e
       NÃO toca em `atual` nem nos pontinhos — quem atualiza os dois é o
       listener de scroll, lendo o que de fato aconteceu.

       O motivo é concreto: pintar o pontinho junto com o pedido de rolagem
       faz o pontinho mentir sempre que a rolagem atrasa, é interrompida por
       um arrasto ou é descartada pelo navegador. Medido no teste: o ponto
       indicava o banner 1 com o trilho ainda parado no 3.

       clientWidth do trilho, e não offsetLeft do slide: cada slide ocupa 100%
       da largura, então a conta é exata e não depende de offsetParent — que
       muda se alguém puser position:relative num ancestral. */
    function ir(i) {
      var alvo = ((i % slides.length) + slides.length) % slides.length;
      var x = alvo * trilho.clientWidth;
      trilho.scrollTo({ left: x });

      /* Rede de segurança: se a rolagem suave não saiu do lugar — rAF
         estrangulado em aba de fundo, webview, navegador antigo — vai de uma
         vez. Melhor um corte seco do que um carrossel que trava.

         `behavior: 'instant'` é obrigatório aqui, e não `trilho.scrollLeft = x`:
         atribuir scrollLeft TAMBÉM obedece ao `scroll-behavior: smooth` do
         CSS, então a proteção contra a rolagem suave travada estaria escrita
         em cima da própria rolagem suave. Medido: num contexto sem rAF, o
         scrollTo suave não andava um pixel em 1 segundo e o scrollLeft= não
         corrigia; com 'instant' chega na hora. */
      clearTimeout(conferirChegada);
      conferirChegada = setTimeout(function () {
        if (Math.abs(trilho.scrollLeft - x) > 2) {
          trilho.scrollTo({ left: x, behavior: 'instant' });
        }
        sincronizar();
      }, 450);
    }

    /* Índice do que está na tela AGORA, não o que pedimos por último. */
    function indiceNaTela() {
      var largura = trilho.clientWidth || 1;
      var i = Math.round(trilho.scrollLeft / largura);
      return Math.max(0, Math.min(slides.length - 1, i));
    }

    /* Lê a posição real e acerta os pontinhos. Chamado de dois lugares: do
       evento de scroll (caminho normal) e do ponto de controle do ir() — não
       dá para depender só do evento, porque há contextos em que ele não é
       entregue (aba em segundo plano, webview com renderização suspensa).
       Medido num painel assim: o scrollLeft mudava e nenhum evento chegava,
       deixando o pontinho preso no primeiro banner para sempre. */
    function sincronizar() {
      var i = indiceNaTela();
      if (i !== atual) { atual = i; pintar(); }
    }

    function pintar() {
      for (var i = 0; i < pontos.length; i++) {
        pontos[i].setAttribute('aria-current', i === atual ? 'true' : 'false');
      }
    }

    function parar() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function tocar() {
      if (!auto || reduz) return;
      parar();
      timer = setInterval(function () { ir(indiceNaTela() + 1); }, intervalo);
    }

    function adiar() {
      parar();
      clearTimeout(retomar);
      retomar = setTimeout(tocar, PAUSA_APOS_TOQUE);
    }

    /* O scroll pode vir do dedo, do trackpad ou do nosso próprio scrollTo.
       Em todos os casos a verdade é a posição final — este listener é o único
       lugar que escreve em `atual` e nos pontinhos.

       Os 140ms esperam a rolagem suave terminar: a 90ms o listener disparava
       no meio da animação e o pontinho piscava num banner intermediário. */
    trilho.addEventListener('scroll', function () {
      clearTimeout(lendoScroll);
      lendoScroll = setTimeout(sincronizar, 140);
    }, { passive: true });

    trilho.addEventListener('pointerdown', adiar);
    trilho.addEventListener('wheel', adiar, { passive: true });

    pontos.forEach(function (p, i) {
      p.addEventListener('click', function () { ir(i); adiar(); });   /* quem pinta é o scroll */
    });

    raiz.addEventListener('mouseenter', parar);
    raiz.addEventListener('mouseleave', tocar);
    raiz.addEventListener('focusin', parar);
    raiz.addEventListener('focusout', tocar);

    /* Aba escondida: o setInterval seguiria contando e, ao voltar, o navegador
       despeja os scrolls acumulados de uma vez. O document.contains evita que
       uma instância antiga — o editor de temas recria a seção a cada ajuste —
       continue rodando um timer sobre um nó que não está mais na página. */
    document.addEventListener('visibilitychange', function () {
      if (!document.contains(raiz)) { parar(); return; }
      if (document.hidden) { parar(); } else { tocar(); }
    });

    pintar();
    tocar();
  }

  function iniciar() {
    var todos = document.querySelectorAll('[data-bn]');
    for (var i = 0; i < todos.length; i++) montar(todos[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  /* O editor de temas troca o HTML da seção a cada alteração; sem isto o
     carrossel morre justamente enquanto a pessoa está configurando ele. */
  document.addEventListener('shopify:section:load', function (e) {
    var raiz = e.target.querySelector ? e.target.querySelector('[data-bn]') : null;
    if (raiz) montar(raiz);
  });
})();